module.exports = __webpack_public_path__ + "static/img/waiting_confirm.e49696bf.png";